(function(){
  var root = document.getElementById('dmr-landing');
  if (!root) return;
  var dmrBundle = 2;

  /* Contador hasta medianoche */
  var clock = document.getElementById('dmrClock');
  function tick(){
    var n = new Date(), e = new Date(n); e.setHours(24,0,0,0);
    var s = Math.max(0, Math.floor((e - n) / 1000));
    var p = [Math.floor(s / 3600), Math.floor(s % 3600 / 60), s % 60].map(function(x){ return String(x).padStart(2, '0'); });
    if (clock) clock.innerHTML = '<span>' + p[0] + '</span>:<span>' + p[1] + '</span>:<span>' + p[2] + '</span>';
  }
  tick(); setInterval(tick, 1000);

  /* Carrusel hero: autoplay 4,2 s, swipe, puntos */
  var car = document.getElementById('dmrCar');
  if (car) {
    var track = car.querySelector('.dmr-car__track'), slides = track.children.length, dots = document.getElementById('dmrDots'), i = 0, timer, resume;
    for (var k = 0; k < slides; k++) {
      var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Imagen ' + (k + 1));
      (function(k){ b.onclick = function(){ go(k); pause(); }; })(k);
      dots.appendChild(b);
    }
    function go(n){ i = (n + slides) % slides; track.style.transform = 'translateX(' + (-100 * i) + '%)'; [].forEach.call(dots.children, function(d, j){ d.classList.toggle('on', j === i); }); }
    function play(){ clearInterval(timer); timer = setInterval(function(){ if (!document.hidden) go(i + 1); }, 4200); }
    function pause(){ clearInterval(timer); clearTimeout(resume); resume = setTimeout(play, 2000); }
    var x0 = null;
    car.addEventListener('pointerdown', function(e){ x0 = e.clientX; pause(); });
    car.addEventListener('pointerup', function(e){ if (x0 === null) return; var dx = e.clientX - x0; if (Math.abs(dx) > 35) go(i + (dx < 0 ? 1 : -1)); x0 = null; });
    go(0); play();
  }

  /* Combos: SOLO tocan el form propio (#dmr-product-form) */
  function dmrCard(n){ return root.querySelector('.dmr-bundle[data-bundle="' + n + '"]'); }
  window.dmrSelectBundle = function(n){
    var card = dmrCard(n); if (!card) return;
    dmrBundle = n;
    root.querySelectorAll('.dmr-bundle').forEach(function(x){ x.classList.toggle('on', x === card); });
    var sn = document.getElementById('dmrStickyName'), sp = document.getElementById('dmrStickyPrice');
    if (sn) sn.textContent = card.getAttribute('data-name');
    if (sp) sp.textContent = card.getAttribute('data-price');
    var inp = document.getElementById('dmr-variant-input');
    if (inp && card.getAttribute('data-variant')) { inp.value = card.getAttribute('data-variant'); inp.setAttribute('value', inp.value); }
  };
  root.querySelectorAll('.dmr-bundle').forEach(function(b){ b.addEventListener('click', function(){ dmrSelectBundle(+b.getAttribute('data-bundle')); }); });

  /* Checkout Releasit Colombia: esta versión lee la variante del form al hacer click
     (patrón HAPPY Colombia, probado 2026-10-25). Respaldo _rsiV2 (patrón Madeca) si la app lo expone. */
  var dmrOpenedVid = null;
  function dmrOpenV2(vid){
    var R = window._rsiV2;
    if (dmrOpenedVid === vid) { R.setState({ isOpen: true, page: 0, pageName: 'fields' }); return; }
    if (dmrOpenedVid && dmrOpenedVid !== vid) {
      var u = new URL(window.location.href);
      u.searchParams.set('dmr_b', String(dmrBundle)); u.searchParams.set('dmr_open', '1');
      window.location.replace(u.toString()); return;
    }
    dmrOpenedVid = vid;
    R.setState({ currentVariantId: vid });
    setTimeout(function(){
      var form = document.getElementById('dmr-product-form');
      if (form) {
        var prev = form.onsubmit; form.onsubmit = null;
        form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        setTimeout(function(){ form.onsubmit = prev || function(){ return false; }; }, 200);
      }
      setTimeout(function(){ var st = R.getState(); if (!st.isOpen) R.setState({ isOpen: true, page: 0, pageName: 'fields', currentVariantId: vid }); }, 500);
    }, 250);
  }
  window.dmrTriggerCOD = function(){
    var card = dmrCard(dmrBundle); if (!card) return;
    var vid = parseInt(card.getAttribute('data-variant'), 10);
    if (!vid) return;
    var fi = document.getElementById('dmr-variant-input'), fq = document.getElementById('dmr-qty-input');
    if (fi) { fi.value = vid; fi.setAttribute('value', vid); }
    if (fq) { fq.value = '1'; fq.setAttribute('value', '1'); }
    if (window._rsiV2 && typeof window._rsiV2.setState === 'function') { dmrOpenV2(vid); return; }
    var rsiSel = '#_rsi-buy-now-button,._rsi-buy-now-button,#rsi_buy_now_button,.rsi_buy_now_button';
    var tries = 0;
    (function clickWait(){
      var rb = document.querySelector(rsiSel);
      if (rb) { rb.click(); return; }
      if (++tries < 60) setTimeout(clickWait, 100);
    })();
  };
  root.querySelectorAll('[data-dmr-cta]').forEach(function(a){
    a.addEventListener('click', function(e){
      e.preventDefault();
      var force = a.getAttribute('data-dmr-force');
      if (force && dmrCard(+force)) dmrSelectBundle(+force);
      dmrTriggerCOD();
    });
  });

  /* Llegada desde recarga por cambio de combo (solo rama _rsiV2) */
  (function(){
    var params = new URLSearchParams(window.location.search);
    var b = params.get('dmr_b'); if (b === null) return;
    if (dmrCard(+b)) dmrSelectBundle(+b);
    var auto = params.get('dmr_open') === '1';
    params.delete('dmr_b'); params.delete('dmr_open');
    try { history.replaceState(null, '', window.location.pathname + (params.toString() ? '?' + params.toString() : '') + window.location.hash); } catch (e) {}
    if (auto) { var t = 0; (function ready(){ if (window._rsiV2 && typeof window._rsiV2.setState === 'function') { setTimeout(window.dmrTriggerCOD, 600); return; } if (++t < 80) setTimeout(ready, 100); })(); }
  })();

  /* Banda de reseñas: cinta continua, pausa al tocar */
  var rt = document.getElementById('dmrRevTrack'), band = document.getElementById('dmrRevBand');
  if (rt && band) {
    rt.innerHTML += rt.innerHTML;
    band.addEventListener('pointerdown', function(){ band.classList.add('hold'); });
    ['pointerup', 'pointercancel', 'pointerleave'].forEach(function(ev){ band.addEventListener(ev, function(){ band.classList.remove('hold'); }); });
  }

  /* Barra fija: aparece al pasar los combos */
  var sticky = document.getElementById('dmrSticky'), bx = document.getElementById('dmrBundles');
  function st(){ if (sticky && bx) sticky.classList.toggle('on', bx.getBoundingClientRect().bottom < 0); }
  window.addEventListener('scroll', st, { passive: true }); st();

  /* Aviso de pedidos */
  var toast = document.getElementById('dmrToast');
  function show(){ if (!toast) return; toast.classList.add('on'); setTimeout(function(){ toast.classList.remove('on'); }, 4000); setTimeout(show, 30000 + Math.random() * 15000); }
  setTimeout(show, 12000);
})();
